import React, { useState } from "react"
import { useSelector } from "react-redux"

import { YES, VIEW, EDIT } from "const"
import { StoreType } from "client/store"
import { okrSessionsRoute } from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import List from "./list"
import Edit from "./edit"
import View from "./view"
import SessionContent from "./view/sessionContent"

const OkrSession = () => {
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const modals = useSelector((state: StoreType) => state.system.modals)

    const [modalLength] = useState(modals.length)

    const { okrModuleAccess } = packageSettings
    const access = userData.accountId === 1 || okrModuleAccess === YES

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${okrSessionsRoute}/${VIEW}/:sessionId`}
                component={modalLength ? SessionContent : View}
            />
            <Route
                path={`${okrSessionsRoute}/${EDIT}/:sessionId`}
                component={Edit}
            />
            <Route
                path={okrSessionsRoute}
                component={List}
            />
        </Switch>
    )
}
export default OkrSession
